import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { MOBILE_PRIMARY } from "../constants/navigation";

export default function BottomNav() {
    const location = useLocation();
    return (
        <nav
            data-testid="bottom-nav-wrapper"
            className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-[#0D1B3E] border-t border-[#F5F0E8]/10"
        >
            <ul className="grid grid-cols-5" data-testid="bottom-nav">
                {MOBILE_PRIMARY.map((item) => {
                    const Icon = item.icon;
                    const active =
                        location.pathname === item.to ||
                        (item.to !== "/app" && location.pathname.startsWith(item.to));
                    return (
                        <li key={item.key}>
                            <NavLink
                                to={item.to}
                                data-testid={`bottom-nav-link-${item.key}`}
                                className={`flex flex-col items-center justify-center py-2.5 gap-1 ${
                                    active ? "text-[#C9A84C]" : "text-[#F5F0E8]/70"
                                }`}
                            >
                                <Icon size={20} strokeWidth={1.6} />
                                <span className="text-[10px] uppercase tracking-[0.16em]">
                                    {item.label}
                                </span>
                            </NavLink>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}
